import * as React from 'react';
import { cn } from '../utils/cn';

export interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Main axis direction */
  direction?: 'row' | 'column';
  /** Wrap behavior */
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  /** Main axis alignment */
  justify?: 'start' | 'end' | 'center' | 'between' | 'around';
  /** Cross axis alignment */
  align?: 'start' | 'end' | 'center' | 'stretch' | 'baseline';
  /** Gap between children */
  gap?: number;
}

const justifyMap: Record<string, string> = {
  start: 'justify-start',
  end: 'justify-end',
  center: 'justify-center',
  between: 'justify-between',
  around: 'justify-around',
};

const alignMap: Record<string, string> = {
  start: 'items-start',
  end: 'items-end',
  center: 'items-center',
  stretch: 'items-stretch',
  baseline: 'items-baseline',
};

export const Flex = React.forwardRef<HTMLDivElement, FlexProps>(
  (
    {
      className,
      direction = 'row',
      wrap = 'nowrap',
      justify = 'start',
      align = 'center',
      gap,
      style,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex',
          direction === 'column' ? 'flex-col' : 'flex-row',
          wrap === 'wrap' ? 'flex-wrap' : wrap === 'wrap-reverse' ? 'flex-wrap-reverse' : 'flex-nowrap',
          justifyMap[justify],
          alignMap[align],
          className
        )}
        style={{ gap, ...style }}
        {...props}
      >
        {children}
      </div>
    );
  }
);
Flex.displayName = 'Flex';
